var map = {
	"./complete-icon-and-name.png": "fIzA",
	"./drive-icon-and-name.png": "Bts5",
	"./fundamentals-icon-and-name.png": "fQa5",
	"./job-description-generator-icon-and-name.png": "VMTN",
	"./live-hr-advice-icon-and-name.png": "Y2sL",
	"./policy-manual-wizard-icon-and-name.png": "qsqT",
	"./surveys-icon-and-name.png": "n6QN",
	"./time-attendance-icon-and-name.png": "ZKhV",
	"./training-icon-and-name.png": "sR31"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VEcQ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools ^\.\/.*\-icon\-and\-name\.png$
// module id = VEcQ
// module chunks = 0